import { serializable, alias, primitive } from 'serializr';

export class ProductSiblingsList {
    
  @serializable
  id?: number;

  @serializable(alias('reporting_period', primitive()))
  reportingPeriod?: string;

  @serializable(alias('reporting_year', primitive()))
  reportingYear?: string;
  
}
